export default __webpack_public_path__ + "static/media/group-169@2x.df7e4dea.png";